import { Col, Row } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { COLORS } from 'theme'

import {
  MainHeading,
  SecondGreyText,
  StyledP,
  SubFLex,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const OtherDetails = ({ studentData }) => {
  const [otherDetails, setOtherDetails] = useState([])
  const splitArrayLocation = list => {
    if (!Array.isArray(list)) return ''
    return list
      .map(item => (item.city_name ? item.city_name : item.state_name))
      .join(', ')
  }

  useEffect(() => {
    const otherData = [
      {
        name: 'Preferred Location',
        value: studentData?.studentPersonalProfile?.isAnywhere
          ? 'Anywhere'
          : splitArrayLocation(
              studentData?.studentPersonalProfile?.preferredJobLocation
            ),
      },
      {
        name: 'Gender',
        value: studentData?.studentPersonalProfile?.gender,
      },
      {
        name: 'Date of Birth',
        value: (studentData?.studentPersonalProfile?.dob && studentData?.studentPersonalProfile?.dob !== '0' && moment(studentData?.studentPersonalProfile?.dob).isValid()) 
          ? moment(studentData?.studentPersonalProfile?.dob).format('DD/MM/YYYY') 
          : '',
      },
      {
        name: 'Secondary Email ID',
        value: studentData?.studentPersonalProfile?.secondaryEmail,
      },
      {
        name: 'Caste',
        value: studentData?.studentPersonalProfile?.caste,
      },
      {
        name: 'Religion',
        value: studentData?.studentPersonalProfile?.religion,
      },
      {
        name: 'Language',
        value: studentData?.studentPersonalProfile?.languages?.toString(),
      },
      {
        name: 'Hobbies',
        value: studentData?.studentPersonalProfile?.hobbies?.toString(),
      },
      {
        name: 'Temporary Address',
        value: (
          <>
            {studentData?.studentPersonalProfile?.corrAddrLine1}
            {studentData?.studentPersonalProfile?.corrAddrLine1 && ','}
            {studentData?.studentPersonalProfile?.corrAddrLine2}
            {studentData?.studentPersonalProfile?.corrAddrLine2 && ','}
            {studentData?.studentPersonalProfile?.corrCity},
            {studentData?.studentPersonalProfile?.corrState},
            {studentData?.studentPersonalProfile?.corrCountry},
            {studentData?.studentPersonalProfile?.corrPostCode}
          </>
        ),
      },
      {
        name: 'Permanent Address',
        value: (
          <>
            {studentData?.studentPersonalProfile?.permAddrLine1}
            {studentData?.studentPersonalProfile?.permAddrLine1 && ','}
            {studentData?.studentPersonalProfile?.permAddrLine2}
            {studentData?.studentPersonalProfile?.permAddrLine2 && ','}
            {studentData?.studentPersonalProfile?.permCity},
            {studentData?.studentPersonalProfile?.permState},
            {studentData?.studentPersonalProfile?.permCountry},
            {studentData?.studentPersonalProfile?.permPostCode}
          </>
        ),
      },
    ]

    setOtherDetails(otherData)
  }, [studentData])
  return (
    <>
      <MainHeading>Other Information</MainHeading>
      <SubFLex column gap="20px">
        {otherDetails?.map((item, index) => (
          <Row style={{ width: '100%' }} key={index + item?.name}>
            <Col span={10}>
              <SecondGreyText color={COLORS.GREY_T_60}>
                {item?.name}
              </SecondGreyText>
            </Col>
            <Col span={2}>
              {' '}
              <SecondGreyText>-</SecondGreyText>{' '}
            </Col>
            <Col span={12}>
              {' '}
              <SecondGreyText>{item?.value}</SecondGreyText>
            </Col>
          </Row>
        ))}
      </SubFLex>
      {studentData?.studentPersonalProfile?.extraCurriculars && (
        <>
          <MainHeading marginBottom={'10px'}>
            ExtraCurricular Activities
          </MainHeading>
          <StyledP
            webkitBox={true}
            dangerouslySetInnerHTML={{
              __html: studentData?.studentPersonalProfile?.extraCurriculars,
            }}
          />
        </>
      )}
    </>
  )
}

export default OtherDetails
